import React from 'react'
import { Fragment } from 'react'
import NavMenuDesktop from '../components/common/NavMenuDesktop'
import NavMenuMobile from '../components/common/NavMenuMobile'
import FooterDesktop from '../components/common/FooterDesktop'
import FooterMobile from '../components/common/FooterMobile'
import NewOrders from '../components/orders/NewOrders'

function NewOrdersPage(props) {
  return (
    <Fragment>
        <div className='Desktop'>
          <NavMenuDesktop user={props.user} />
        </div>
        <div className='Mobile'>
        <NavMenuMobile />
        </div>
      
        <NewOrders user={props.user}/>
        
        <div className='Desktop'>
        <FooterDesktop />
        </div>

        <div className='Mobile'>
          <FooterMobile />
        </div>
      </Fragment>
  )
}

export default NewOrdersPage
